import React, { FC } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { IMessagesListProps } from "../types";
import { MessageItem } from "./MessageItem";

const useStyles = makeStyles(() => ({
  list: {
    marginRight: 2,
    padding: "8px 22px 0 0",
    "overflow-y": "overlay",
    display: "flex",
    flexDirection: "column-reverse",
  },
  noMessages: {
    fontSize: 14,
    color: "#989BA8",
    textAlign: "center",
    paddingBottom: 260,
  },
}));

export const MessagesList: FC<IMessagesListProps> = React.memo(
  ({ messagesContainerRef, messages, makeSeen }) => {
    const classes = useStyles();

    return (
      <div
        ref={messagesContainerRef}
        className={clsx(classes.list, "transparent-scrollbar")}
      >
        {!messages.length && (
          <div className={classes.noMessages}>No messages found.</div>
        )}
        {messages.map((message) => (
          <MessageItem key={message.id} message={message} makeSeen={makeSeen} />
        ))}
      </div>
    );
  },
);
